function mediaMOdal () {
  let $carousel; // declare globally

  window.initializeOwlCarousel = function () {
    $carousel = $('.product-media-owl-carousel'); // assign to global variable

    $carousel.owlCarousel({
      loop: false,
      dots: false,
      margin: 0,
      nav: true,
      dragEndSpeed: 600,
      mouseDrag: true,
      touchDrag: true,
      responsive: {
        0: { items: 1 },
        600: { items: 1 },
        1000: { items: 1 }
      }
    });
  };

  window.initializeOwlCarousel();

  // NOW this works because $carousel is defined above
  $carousel.on('changed.owl.carousel', function (event) {
    const currentIndex = event.item.index;
    const $currentItem = $(event.target)
      .find('.owl-item')
      .eq(currentIndex)
      .find('[data-media-id]');

    if ($currentItem.length) {
      const fullMediaId = $currentItem.attr('data-media-id');
      window.lastViewedMediaId = fullMediaId;
      console.log('lastViewedMediaId set to:', fullMediaId);
    }
  });

  function syncGalleryToLastViewed() {
    const mediaGallery = document.querySelector('media-gallery');
    const lastMediaId = window.lastViewedMediaId;

    if (mediaGallery && lastMediaId) {
      const items = mediaGallery.querySelectorAll('[data-media-id]');
      const lastPart = lastMediaId.split('-').pop();

      const match = Array.from(items).find(el =>
        el.dataset.mediaId === lastMediaId ||
        el.dataset.mediaId?.endsWith(lastPart)
      );

      if (match) {
        mediaGallery.setActiveMedia(match.dataset.mediaId, false);
      }
    }
  }

  document.body.addEventListener('modalClosed', syncGalleryToLastViewed);
};
mediaMOdal ();